import React from 'react'

import PropTypes from 'prop-types'

import Styles from './styles.scss'


// A prompt that renders without taking over the page. There's no `<dialog>`
// here at all, so nothing joins the document's top layer, nothing else in the
// document goes inert, and there's no accessible name, since a container that
// isn't a dialog has no business announcing itself as one.
//
// The dashboard's banner preview is the caller that wants this. It mounts the
// app inside its own page, where a modal dialog would inert the rest of the
// dashboard, the previewer's own close button included.
//
export default function ModelessDialog({ children }) {
  return (
    <div className={ Styles.root }>
      { children }
    </div>
  )
}

ModelessDialog.propTypes = {
  children: PropTypes.node,
}
